import {
  sentryClient,
  sentryKey,
  sentryProject,
  version,
  sentryRegex,
} from 'utils/settings';

const sentryEnabled =
  window.ikea.sentry && sentryKey && sentryProject && sentryClient && version;
const release = `igift-agent@${version}`;

if (sentryEnabled) {
  window.ikea.sentry.register(
    sentryProject,
    sentryKey,
    sentryClient,
    release,
    1, // Log 100% of errors for now
    [sentryRegex]
  );
}

export const reportError =
  sentryEnabled || console.warn('[igift] Sentry is not active')
    ? (e: Error | string) => {
        window.ikea.sentry.store(
          e,
          sentryProject,
          sentryKey,
          sentryClient,
          release,
          1
        );
      }
    : (e: Error | string) => {
        console.error(e);
      };
